import { PlaycastGamepadDevice, XInputValues } from '@playcastdotio/CoreTypes';

// Browser capture of gamepad sticks use y axis inverted from XInput and WebGL
const toShort = (raw: number, reverse: boolean) => (((reverse ? 0 - raw : raw) + 1) * 32767.5 - 32768) | 0;

// Gamepad triggers are 0 to 1, XInput triggers are 0 to 255
const toByte = (raw: number) => (raw * 255) | 0;

const toWord = (buttons: GamepadButton[]) =>
  (buttons[12]?.pressed ? XInputValues.DPAD_UP : 0) |
  (buttons[13]?.pressed ? XInputValues.DPAD_DOWN : 0) |
  (buttons[14]?.pressed ? XInputValues.DPAD_LEFT : 0) |
  (buttons[15]?.pressed ? XInputValues.DPAD_RIGHT : 0) |
  (buttons[9]?.pressed ? XInputValues.START : 0) |
  (buttons[8]?.pressed ? XInputValues.BACK : 0) |
  (buttons[10]?.pressed ? XInputValues.LEFT_THUMB : 0) |
  (buttons[11]?.pressed ? XInputValues.RIGHT_THUMB : 0) |
  (buttons[4]?.pressed ? XInputValues.LEFT_SHOULDER : 0) |
  (buttons[5]?.pressed ? XInputValues.RIGHT_SHOULDER : 0) |
  (buttons[0]?.pressed ? XInputValues.A : 0) |
  (buttons[1]?.pressed ? XInputValues.B : 0) |
  (buttons[2]?.pressed ? XInputValues.X : 0) |
  (buttons[3]?.pressed ? XInputValues.Y : 0);

export const convertGamepads = (gamepads: Gamepad[]) => {
  const raw = gamepads.map((g) => {
    return {
      axes: g.axes,
      buttons: g.buttons.map((b: GamepadButton) => {
        return {
          pressed: b.pressed,
          touched: b.touched,
          value: b.value,
        };
      }),
      id: g.id,
      index: g.index,
      mapping: g.mapping,
      timestamp: g.timestamp,
    };
  });

  return raw.map((r) => {
    const output: PlaycastGamepadDevice = {
      deviceId: r.index,
      id: r.id,
      timestamp: r.timestamp,
      xInput: {
        wButtons: toWord(r.buttons),
        bLeftTrigger: toByte(r.buttons[6].value),
        bRightTrigger: toByte(r.buttons[7].value),
        sThumbLX: toShort(r.axes[0], false),
        sThumbLY: toShort(r.axes[1], true),
        sThumbRX: toShort(r.axes[2], false),
        sThumbRY: toShort(r.axes[3], true),
      },
    };

    return output;
  });
};
